import { useQuery } from 'react-query';
import useFeatureToggle from '@guestyci/feature-toggle-fe/useFeatureToggle';

import utils from 'utils';
import isDPTAvailable from 'API/handlers/dptData';
import { introPopupSplits } from 'config/splits';

const useDPTData = () => {
  const { authenticatedData } = utils.getLocalStorageByKey('authenticatedData');
  const [, { gfhDptPaidFlow, gfhDptTrialUsers }] =
    useFeatureToggle(introPopupSplits);
  const { data: isAvailableForDPT } = useQuery({
    enabled: gfhDptPaidFlow || gfhDptTrialUsers,
    queryKey: ['isDPTAvailable'],
    queryFn: () => isDPTAvailable(authenticatedData.baseUserInfo.accountId),
    retry: 1,
  });

  return isAvailableForDPT;
};

export default useDPTData;
